import { render, staticRenderFns } from "./DevelopmentPlanModal.vue?vue&type=template&id=33c0d519&scoped=true"
import script from "./DevelopmentPlanModal.vue?vue&type=script&lang=js"
export * from "./DevelopmentPlanModal.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentPlanModal.vue?vue&type=style&index=0&id=33c0d519&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c0d519",
  null
  
)

export default component.exports